import { render, staticRenderFns } from "./LanguagesSelectorOption.vue?vue&type=template&id=087558ea"
import script from "./LanguagesSelectorOption.vue?vue&type=script&lang=js"
export * from "./LanguagesSelectorOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports